import { FC, ReactNode } from 'react';
import {
  render,
  StoryblokRichtext,
} from 'storyblok-rich-text-react-renderer-ts';

import { isStoryblokRichTextPresent } from '../../utils/renderStoryblokRichText';
import { Image } from '../Image';
import { RichTextLink } from '../RichTextLink';

interface Props {
  author: StoryblokRichtext;
  text: StoryblokRichtext;
  thumbnail?: StoryblokImage;
}

const paragraph = (children: ReactNode) => (
  <p className="mb-3 text-md md:text-lg">{children}</p>
);

const footer = (children: ReactNode) => (
  <footer className="aa-prose max-w-none text-neutral-4">{children}</footer>
);

export const Quote: FC<Props> = ({ author, text, thumbnail }) => (
  <section className="flex flex-col items-center text-center">
    {thumbnail?.filename && (
      <div className="mb-3 w-12 md:mb-6 md:w-14">
        <Image
          alt={thumbnail.alt}
          shape="circle"
          src={thumbnail.filename}
          width={64}
        />
      </div>
    )}
    <blockquote className="my-0">
      {render(text, {
        markResolvers: { link: RichTextLink },
        nodeResolvers: { paragraph },
      })}
      {isStoryblokRichTextPresent(author) &&
        render(author, {
          markResolvers: { link: RichTextLink },
          nodeResolvers: { paragraph: footer },
        })}
    </blockquote>
  </section>
);
